import React, { useState } from 'react';
import styles from './BrandDetail.module.scss';
import { Button, Col, Container, Input, Label, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const documents = [
    { label: 'Business License' },
    { label: 'Trademark Registration' },
    { label: 'Other Relevant Documents' },
    { label: 'Agreement Documents' },
];

const BrandDetail = ({ setIsBrandDetail, columnsData, selectedRow }) => {
    const [fileNames, setFileNames] = useState({});
    const navigate = useNavigate();
    const isBrandEdit = true;

    const handleEditBrandClick = () => {
        // Navigate to the Edit Brand route when button is clicked
        navigate('/products/brand/edit', { state: { isBrandEdit } });
    };

    const handleFileChange = (event, index) => {
        const file = event.target.files[0];
        if (file) {
            setFileNames(prevState => ({
                ...prevState,
                [index]: file.name,  // Store the filename based on the document index
            }));
        }
    };

    return (
        <div className={styles.mainBrandDetailContainer}>
            <div className={styles.backButton}>
                <Button color="link" onClick={() => setIsBrandDetail(false)}>
                    <i className="fa fas fa-caret-left"></i>
                    <span>Back to Brands Information</span>
                </Button>
            </div>

            <h5 className={styles.sectionHeading}>Brand Detail</h5>

            <Container fluid className={styles.brandDetailsContainer}>
                <Row className={styles.brandDetailRow}>
                    <Col xl="4" className={styles.brandDetailColumn}>
                        <div className={styles.detailBox}>
                            {columnsData?.map((column, index) => (
                                column.selector && (
                                    <Row key={index} className={styles.columnDataRow}>
                                        <Col className={styles.columnName}>{column.name}:</Col>
                                        <Col>{column.selector(selectedRow)}</Col>
                                    </Row>
                                )
                            ))}
                        </div>
                    </Col>

                    <Col xl="8" className={styles.rejectionReasonColumn}>
                        {selectedRow?.status === 'Rejected' && (
                            <div className={styles.rejectionReasonBox}>
                                <h5 className={styles.rejectionHeading}>Rejection Reason</h5>
                                <Row className={styles.rejectionReasonRow}>
                                    <Col className={styles.rejectionIssueColumn}>
                                        <p className={styles.rejectionColumnHeading}>Issue:</p>
                                        <p>The submitted business license and trademark registration documents were either incomplete or missing.</p>
                                    </Col>
                                    <Col className={styles.rejectionSolutionColumn}>
                                        <p className={styles.rejectionColumnHeading}>Solution:</p>
                                        <p>Please ensure that you upload the complete and most recent versions of your business license and trademark registration.</p>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Col>
                </Row>

                <Row className={styles.attachedDocumentsRow}>
                    <Col className={styles.attachedDocumentsColumn}>
                        <h5 className={styles.attachedDocumentHeading}>Attached Documents</h5>
                        <div className={styles.documentList}>
                            {documents?.map((doc, index) => (
                                <Row key={index} className={styles.documentItem}>
                                    <Col lg={4} xl={3}>
                                        <Label>{doc.label}:</Label>
                                    </Col>
                                    <Col lg={8} xl={9}>
                                        <div className={styles.uploadDocumentContainer}>
                                            <Input
                                                type="file"
                                                id={`fileUpload-${index}`}
                                                className="d-none"
                                                onChange={(e) => handleFileChange(e, index)}  // Pass index to handleFileChange
                                            />
                                            <Button
                                                color="warning "
                                                className={styles.uploadDocumentButton}
                                                onClick={() => document.getElementById(`fileUpload-${index}`).click()}
                                            >
                                                Upload Document
                                            </Button>
                                            {fileNames[index] && (  // Display filename for the specific document
                                                <div className={styles.fileNameDisplay}>
                                                    {fileNames[index]}
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    </Col>
                </Row>

                <Container fluid className={styles.actionButtonsContainer}>
                    <Button type="button" color="primary">Delete Brand</Button>
                    <Button
                        type="button"
                        color="primary"
                        onClick={handleEditBrandClick}
                    >
                        Edit Brand Information
                    </Button>
                    {selectedRow?.status === 'Rejected' && (
                        <Button type="button" color="primary">Re-submit application</Button>
                    )}
                </Container>
            </Container>
        </div>
    )
}

export default BrandDetail;